module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "ct"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Chapter I")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("‘All the time the wind was south-west you were deadly keen on seals.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Was I?’ Allen idly stopped fumbling in the pocket of his coat, then asked with interest: ‘Been seeing your friend the boatman again?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Yes. Why?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘This meteorological knowledge.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I suppose you think I’m incapable of noticing anything for myself.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘No.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There were blue fishing-boats in the harbour pool. Allen could see them reflected in blots of opaque colour on the glass of a framed engraving which faced the window. Sir Cloudesley Shovel and his men drowning between the Gilstone and Retarriers, 1707. The blots did not seem to move, but the fishing-boats were dipping and rocking as gusts darkened the water. A web of fragile brilliance lay upon the pool and upon the distant waters of the Road. The dining-room was shadowy with reflected light.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _vm._v("‘I can actually remember your saying: “at the Zoo they’ll answer to obscene names: Milly and Gertie.”’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘The seals aren’t the point,’ replied Allen, beginning to clean his pipe.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Philip asked: ‘Then what is?’ merely to keep up the discussion. Like a becalmed kite, it required continual jerks. Another argument occurred to him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘There’d be eight of us in the launch.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Nine,’ Allen corrected, ‘including the boatman.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Well, then?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘What?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The light played over Philip’s face, which was beginning to peel. Sunburn made it agreeable, almost handsome. But against the dark blue sky and the rakish mop-headed palms of the hotel garden, Philip, in his townish clothes, looked plump and rather absurd. Or one could put it that, behind him, the gorgeous colours of the afternoon beyond the pane seemed crude, unreal. He was smiling with exasperation.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Well, then, what earthly difference can it make?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘None.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Then you’ll come?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘No.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘But, if it doesn’t, why won’t you?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Because I don’t want to.’ Allen yawned patiently.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Rot. If you don’t come, it’s because of him.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Just as you like. It’s because of him.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Philip sighed; saying with a certain pathos:")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Oh, Allen, you are utterly impossible sometimes, you know.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("They were alone in the dining-room. The other visitors had either finished their meal already or were off for the day picnicking on one of the smaller islands. Within the house there was no sound. The tide was in, the waves splashing in sharp slaps against the terrace wall. On the gravel, the gulls were "), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _vm._v("jostling like hens for the scraps of food scattered by the waiter. A gust gave a whip-crack to the rope of the green flagstaff. The breeze was freshening.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘In twenty minutes they’ll have started.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Allen finished cleaning his pipe, filled it carefully, lit it, puffed. Then he said:")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘But why should this stop your going?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Oh, I shall go, of course. Don’t flatter yourself.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Allen watched through the window a tall young man in light brown tweeds come hurriedly into view round the angle of the hotel buildings. He was fair-haired, childishly pink. He frowned. There was nobody else on the terrace.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Colonel Page won’t be there, you know,’ Philip added. ‘He went off early this morning to the western rocks.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I wonder,’ said Allen, watching, ‘whether the desire to photograph puffins during the love act could be classified as any form of sexual mania.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘It ought. It’s lasted for twenty years.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The young man, frowning anxiously, had disappeared.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I’m going,’ said Allen, rising abruptly.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Where?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Oh, anywhere. Out of this house, for the present.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘You aren’t going to explain to him or anything?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I’ll explain whatever you like, if you tell me what to say.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Explain why we ever came to this place at all,’ thought Philip, angry for a moment.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("An ordnance map spread out under the lamplight on the tablecloth in Allen’s lodgings. Menavawr. Inisvowels. Nornor. Ganilly. Hanjague. Miles and miles out in the Atlantic. Absolutely no question of meeting anyone. They’ll never guess. A poster seen in the Warren Street tube station had released sensory and motor images of gulls, passing, repassing. And from the greasy filth of Paddington goods siding one false "), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }), _vm._v("overpowering breath of rotten seaweed. My God, how utterly terrific. The Franck Symphony contributed three bars. A Saint-Blaise, a la Zuecca. Can’t we start "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("now?")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Oh, it doesn’t matter. Page ought to understand you if anybody does.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As they passed together from the dining-room into the faded sunlit lounge, Allen experienced a pang of boredom which was like hunger or love, curdling the food in his stomach, making him feel helpless and physically sick.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Down the smuggler’s alley, high-walled, overgrown with dangling fuschia, they idly strolled, by a path which led to the cliff. Cottages, lime-washed or crude pink in the ocean sunlight, surrounded a stony foreshore littered with empty tins, vegetables, smashed baskets and mouldering boots. Their threads of smoke curled up faintly against the sea-line. The fields beyond were full of wallflowers and shrivelled daffodils. Two donkeys were coupling with a loud monotonous braying which echoed from the rocks.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘You’ll miss the launch,’ said Allen.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Well, you don’t really expect me to go alone, do you?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I can’t see why not.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘For one thing, I’m not specially keen to, now. Other people,’ Philip smiled maliciously, ‘are allowed to change their minds.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Allen did not reply. ‘I’ve been fairly asking for it, all through lunch,’ he thought. ‘All the same, it’s unfortunate, because if we’re together all this afternoon we shall certainly have a row.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But Philip had, as it happened, at that moment seen a picture. Squinted at for an instant with half-closed eyelids, Morning Point, Peninnis and an intervening segment of the "), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _vm._v("Atlantic had all at once composed into a very striking arrangement of interlocked triangles. The effect suggested an agreeable line of treatment. Colour laid on with the palette-knife or smeared in with one’s thumb. A few hours’ work; bold, attractive, easy. In his excitement he unwisely began trying to explain the idea to Allen.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘You quite follow?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I think so. Just blue and green and grey.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘You mean you think it’s obvious?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Oh, no. Not obvious, certainly.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Well then, what’s wrong with it?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I never said anything was wrong. As a matter of fact, I can’t possibly tell until I’ve seen what you make of it.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘No, of course you can’t. That’s the worst of your not understanding the thing practically. You have to judge it from a purely literary point of view.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Allen was thinking: ‘Now, I won’t be the one to start this. It would be too ignominious to lose one’s temper over Philip’s daubs.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He said:")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘What about your view of the harbour?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Oh, that, naturally, I shall scrap.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘What’s the matter with it all of a sudden?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I must say, I should have thought "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("anyone")]), _vm._v(" could have seen.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘You mean that the drawing’s all wrong?’ [Why am I so spiteful today?] ‘But seriously, Philip, I did like that thing.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘You know, Allen,’ Philip’s tone softened a little, ‘for an intelligent person you’ve got the worst taste of anybody I ever met.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Have I? I dare say. But from “a purely literary point of view” it appealed to me. It was so extraordinarily, well – interesting. The huge empty foreground and those boats like collapsed tents. And then the stone pier looking as if "), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }), _vm._v("it was glued on to the islands beyond, without any attempt to suggest distance at all. It reminded me of that picture by Matisse.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But this speech, to judge from a side-glance at Philip’s face, had been altogether tactless. Allen added rather weakly:")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Or perhaps it isn’t Matisse.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I suppose,’ Philip was peevish again, ‘you’ve made up your mind that this new thing isn’t going to be “interesting.”’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Further concession would be mere insult.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Not "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("so")]), _vm._v(" interesting,’ said Allen firmly.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I thought not. You see it’s just this unfortunate craving for the bizarre which handicaps you, every time. What you call interesting is so often merely quaint, or worse.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘And what "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("you")]), _vm._v(" call interesting, is?’ Allen had begun grinning provokingly, in spite of himself. Philip seeing it, grinned also, but his self-satirical tone was strained:")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Well, I must say – without being too personal – that I do think I’ve got an enthusiasm for, one might call them, more "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("genuine")]), _vm._v(" forms of life. I rather prefer to tackle the subjects that you think – though you don’t seem to have got the honesty to admit it—obvious; and extract something from "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("them.")]), _vm._v(" It’s easy enough to be “interesting” in your way.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘And these “genuine forms of life” that you extract things from, include?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Oh, if you want a catalogue – well, put it that I’m not "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("afraid")]), _vm._v(" of anything. One’s got to have the nerve. I want to do picture-postcard sunsets, cows crossing a stream, yes, and hunting scenes, children making daisy-chains, a cat with her kittens …’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘And boatmen?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("That had done it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Yes, boatmen. As a matter of fact, that’s a particularly apt example. Because one of the worst consequences of your attitude is that it makes you so impossibly snobbish. Anyone "), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _vm._v("whom you suspect of the ghastly crime of being ordinary is, of course, utterly beneath your notice.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Utterly.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("From the headland they overlooked quivering sheets of intense light, dotted with black lumps, like worms-cast on a smooth lawn, the Western Rocks. On one of these rocks knelt Colonel Page, cramped in his cache of stones, peering forward through a chink, breathing heavily and gripping the pipe between his teeth in his excitement, as his hairy fingers toyed with the rubber bulb of the camera shutter. Peninnis stands amidst its own enormous ruins; clumsy smooth shapes of protean aspect, at different angles, to different eyes. One sees there the winged horse and the gorgon, molars or fists of giants, a temple’s architrave, heads of nubians and of pythons thrust from beneath immense burdens of stone; thigh, torso, buttocks, limbs, phallic symbols male and female. About fifty yards from the shore, the curded foam was bubbling over a huge slab, channelled deeply by the tides. Philip had noticed it on their first walk here, the day of their arrival. ‘I say, Allen, isn’t that absolutely Epstein? Do you see, three corpses, and the centre one has got its stomach eaten out by rats?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘If you did any kind of creative work you’d soon learn that one’s own point of view "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("isn’t enough.")]), _vm._v(" You’ve got also to look at things in the way that your so-called uninteresting and ordinary people look at them.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Very well, then,’ Allen roused himself. The strong air was making him yawn. ‘How would an ordinary person look at that rock?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘In the first place,’ began Philip, with great deliberation, ‘it’s obviously quite impossible for me to answer that question unless I know a good deal more about the kind of “ordinary” person to which you’re referring. Your definitions are so delightfully vague and arbitrary.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }), _vm._v("Holding a match to his pipe, Allen thought: ‘Shall I?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘All right. Take Victor Page.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Philip frowned. Then he said coldly:")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Very well.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Allen watched him, grinning.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Come along. How would he?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I suppose you think it’s immensely funny to drag Page’s name in on all occasions. Some people wouldn’t harp on it quite so much, considering –’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘You mean that you haven’t the slightest idea. Well, I’ll tell you. He’d look at it and say that it was a rock. A big rock. Now. How does that help you?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Frowning, Philip sat down on a boulder.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I must say this, Allen—since you insist on discussing him – that I only hope Page understands your childish behaviour as well as I do. At breakfast it was damnable.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘What did I do at breakfast? Well, we’d always had separate tables before. And if you can be civil to him and his uncle during a whole meal, well, I can’t.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Philip sighed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I simply give you up. One would think it was a mortal offence to have been at school with you.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I do wish you could get it clear in your head that, at school, we were in different houses. I barely knew him.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Oh, very well then. I only know that he nearly pulled your arm off when we first ran into them on the pier.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘My dear Philip, don’t the old boys of your school –? Oh, of course, I forgot. But imagine the effect. Landing from a steamer. In a place like this. The nervous shock would be considerable. The rest was pure tribal emotion.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘It’s easy enough to sneer at people whose impulses aren’t always negative.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This, from Philip, was surprisingly acute. Allen, stung for a moment, replied with heat:")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _vm._v("‘Even with your latest theories, I suppose you’ll hardly be hypocrite enough to pretend that Page doesn’t loathe me as much as I loathe him?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘At least he can be decently civil.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Haven’t I been?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Well, in a beastly way. I can see all sorts of meanings in the things you say to him. Probably he’s much more sensitive than you think.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘And I can see all sorts of meanings in the things he says to me. You study him a bit more closely, Philip. Remember, you’ve got to get thoroughly at his point of view.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Philip drew in a deep breath, rather ostentatiously biting his lips.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Every day, each time we meet, there’s some unpleasantness in the air. Look at this afternoon. It’s getting intolerable.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Quite. Well, what do you suggest we do?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I must say, I should have thought it was for you to suggest something.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Again Allen lit his pipe; this time, as it seemed to Philip, with deliberate slowness.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Go back to London,’ he said at last.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Do be reasonable.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘You’ve heard nothing yet?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Is it likely?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Philip rose to his feet, stretching himself wearily: posture of bored crucifixion, against the sea.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I thought Joan would have written.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘To treat me to mother’s comments? No. She’d spare me those.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘She’ll let you know when things have calmed down.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘If they do.’ Philip yawned and sighed. ‘I sometimes wonder whether one’ll ever go back to that house.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘What if you don’t?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘God knows. Clear out abroad, I suppose.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }), _vm._v("Down at the harbour, Allen had read the names of the tramps at their moorings – "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Young Ernie. Justifier. Realize. United Friends.")]), _vm._v(" They had watched the fair-haired boy from the Danish timber vessel strolling with three girls under the palisades of the ruined fort, rust-bitten by the spray. He had picked off sharp flakes of iron with his fingers, and the girls laughed. Philip in sea-boots on Havre quay, beneath shuttered houses and the windows from which bolsters limply hang.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘You were an utter lunatic,’ said Allen, with a half-admiring grin.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Their mood brightened.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I wonder when I really decided to do it.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘You certainly fixed things up pretty quickly.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I believe it was after that ghastly tea-party of mother’s; when Currants asked me in front of those two hags when I was going to get something into the Academy.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Did she really? You never told me that.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘My God, that’s nothing. It wasn’t worth mentioning. The only wonder is I stuck the whole show as long as I did.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Their pleased smiles slowly shrank. Allen kicked a pebble with his heel. Philip’s voice was peevish again:")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘And meanwhile?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Meanwhile, what?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘How are we going to carry on here?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Allen said good-naturedly:")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Oh, I suppose I’ll do my best.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘After all,’ he was thinking, ‘Philip’s got himself into rather a hole, and certainly I’ve helped him there. And if Page and I have a row, he suffers for it. Properly appreciated, Philip’s a martyr – of sorts.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Only don’t expect too much,’ he added.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I knew you’d see it like that’ Philip was, as usual, "), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }), _vm._v("mistakenly touched by the suddenness of Allen’s softenings – or weakenings. He was eagerly conciliatory:.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Mind you, Allen, I absolutely understand your point of view.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Well, to a certain extent they had had it out, and perhaps the situation was easier. They had, at least, not quite quarrelled. And already, as they began to descend the path, Philip was contentedly launched into a fresh explanation of his picture-to-be. ‘I shall do five or six right off now that I’ve started. I feel I’ve got the hang of this place at last. And if we do go back to town there’s certain to be one of those newspaper stunts on. They do it for advertisement, you know. You send you stuff up, and if they like it, it gets hung in their show. It wouldn’t be so bad for a beginning. And I think it’d make a great impression in the home, don’t you? At any rate, it would show mother that I mean business. If only she’d get that much clear.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘You might write some more poetry too, don’t you think?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Allen thought:")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘How strange. I said that in the sort of tone one uses to a child.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The crescent of the harbour rose into view. ‘Yes, it’s funny you should ask, because only this morning I had the really brilliant idea of combining those two old things about the gulls at Vauxhall Bridge. With a new one. You see the contrast.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Allen nodded seriously. ‘But I only caught bits of what he was saying. I must get into the habit of listening carefully. It distracts the mind. Since I’ve been here, I’ve done far too much thinking.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The pretty little buildings along the shore. Rat Island. The boats. The sparkling water. Again that slight sharp qualm of nausea, just under the plexus. Boredom belongs to the group of cancerous diseases. Can I stand this for another whole fortnight?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_14"
    }
  }), _vm._v("A cormorant, startling them with its queer cry, broke flapping from unseen rocks below and vanished into the empty gulf of light westward, like an absurd impulse of desperation, towards America.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36006e44","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/03_Chapter1.vue
// module id = 69
// module chunks = 0